// Playable Memories — short flashback sequences unlocked by family keepsakes.
// Each memory has 4–6 "beats" that play in sequence. They begin warmly and
// end with something wrong. Completing a memory grants composure once.

export const MEMORIES = {
  keepsake_watch: {
    key: "keepsake_watch",
    title: "The Pocket Watch",
    subtitle: "You are eight. It is Christmas Eve.",
    hint: "unlocked by — Dad's Pocket Watch (Ch. 2)",
    beats: [
      { kind: "warm",
        text: "Dad is teaching you to wind the pocket watch. He turns your hand for you, gently, three clicks to the right." },
      { kind: "warm",
        text: "'Three clicks,' he says. 'Not four. Four is too many. It hurts the spring.'" },
      { kind: "warm",
        text: "You laugh. He laughs. You count together. One. Two. Three." },
      { kind: "warm",
        text: "He says, 'Whatever happens, if you're ever lost, you listen for this ticking. That's me. That's how you find me.'" },
      { kind: "wrong",
        text: "You are fourteen. His body is beside the security desk. The watch is still in your hand. You have not wound it in six days.",
        subline: "It is still ticking." },
    ],
    composure_reward: 18,
    journal: "MEMORY — The Pocket Watch. Three clicks. Not four.",
  },

  keepsake_photo: {
    key: "keepsake_photo",
    title: "The Beach Photograph",
    subtitle: "You are three. Miriam is alive. You do not remember this.",
    hint: "unlocked by — Photo of Mom and Dad (Ch. 3)",
    beats: [
      { kind: "warm",
        text: "The camera clicks. Salt in the air. Your mother's hair is longer than you've ever seen in a photograph." },
      { kind: "warm",
        text: "Dad is kneeling in the sand behind you, holding your small hand steady on a plastic shovel." },
      { kind: "warm",
        text: "Your mother says, 'One more, Jack. Look at me, sweetheart.'" },
      { kind: "wrong",
        text: "She is not looking at the camera. She is looking at something behind it. Something small. Something on the sand.",
        subline: "Something in the shape of a bisected circle, burned into the wet grain." },
      { kind: "wrong",
        text: "She turns her face and smiles at the lens and never once looks down at the mark." },
    ],
    composure_reward: 14,
    journal: "MEMORY — The Beach Photograph. The mark was there before I was born.",
  },

  keepsake_recorder: {
    key: "keepsake_recorder",
    title: "Mother's Recorder",
    subtitle: "You are four. There is a storm. She is reading to you.",
    hint: "unlocked by — Miriam's Tape Recorder (Ch. 6)",
    beats: [
      { kind: "warm",
        text: "Rain on the window. Miriam pulls the blanket up under your chin and opens a book of Halloween stories." },
      { kind: "warm",
        text: "'On the last night of October,' she reads, 'the door between worlds stands very slightly open.'" },
      { kind: "warm",
        text: "You giggle. You are not afraid. Not yet." },
      { kind: "wrong",
        text: "The rain stops all at once. The book in her hands is no longer a book. It is a stack of laboratory notes.",
        subline: "She continues to read as if nothing has changed." },
      { kind: "wrong",
        text: "'Subject J-14,' she reads to you softly. 'Neurological receptivity — exceptional. Sedation — minimal. Duration of exposure — since conception.'" },
      { kind: "wrong",
        text: "She smooths your hair. She kisses your forehead. She says, 'Sleep now, sweetheart. Sleep. Sleep. Sleep.'" },
    ],
    composure_reward: 12,
    journal: "MEMORY — Mother's Recorder. She was reading me the file.",
  },
};

export const MEMORY_KEYS = Object.keys(MEMORIES);
